import React, { useEffect, useRef, useState } from "react";

/** Libraries */
import { Col, Container, Row } from "react-bootstrap";
import { m } from "framer-motion";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import { useLocation } from "react-router-dom";

/** Components */
import { fadeIn } from "../../Functions/GlobalAnimations";
import Buttons from "../../Components/Button/Buttons";

/** style */
import "../../../Assets/scss/MedicalCounsellingIndia/pages/home.scss";
import CommonContactButton from "../../Components/AnotherButton/CommonContactButton";
import MetaTags from "../../Components/MetaTags";
import "./DirectAdmissionInBptInPune.scss";

/** top college details */

function AdmissionThroughManagementQuota() {
  const [formLoading, setFormLoading] = useState(false);
  const collegeSectionRef = useRef(null);
  const location = useLocation();

  // const collegeTitle = collegeName
  // .split("-")
  // .map((curElem) => {
  //   if (exceptions.includes(curElem)) return curElem;
  //   return curElem.charAt(0).toUpperCase() + curElem.slice(1);
  // })
  // .join(" ");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "all" });

  const onSubmit = (data) => {
    console.log(data);
    setFormLoading(true);
    toast.success("Your message has been sent successfully!", {
      theme: "colored",
    });

    setTimeout(() => {
      setFormLoading(false);
    }, 1000);
  };

  const handleKeyDown = (event) => {
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
    const isNumberKey = !isNaN(Number(event.key)) && event.code !== "Space";

    if (!allowedKeys.includes(event.code) && !isNumberKey) {
      event.preventDefault();
    }
  };

  /** scroll to college */

  useEffect(() => {
    if (
      location.search.includes("scrollToCollege=true") &&
      collegeSectionRef.current
    ) {
      collegeSectionRef.current.scrollIntoView({ behavior: "smooth" });
      console.log("hi");
    }
  }, [location.search]);

  return (
    <>
      <MetaTags
        title="MBA Admission Through Management Quota 2026 – Direct MBA Guidance"
        description="Secure your MBA admission through management quota in top colleges for 2026. Expert guidance & consultation.   Call now: 9730858444 for hassle-free admission."
        keywords=" MBA management quota, direct MBA admission, MBA private college admission, management seat MBA, MBA quota admission "
      />

      {/* banner Parallax Scrolling End */}

      {/* instruction section start  */}
      <section className="bg-lightgray py-[150px] pb-[100px] lg:py-[50px]  md:py-[80px] md:pb-[120px]  sm:py-[100px]">
        <Container>
          {/* How to get Admission */}
          <div className="">
            <div>
              <div className="!text-[#616162] mt-4  ">
                <h1 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-normal">
                  MBA Admission Through Management Quota: A Complete Guide for
                  2026
                </h1>
                <div className="mt-3">
                  In today’s highly <b>competitive</b> <b>academic</b>{" "}
                  <b>environment</b>, <b>pursuing</b>
                  an MBA from a reputed institution is a dream for many
                  students. However, not everyone is able to secure a seat
                  through merit-based exams due to intense competition and
                  limited seats. This is where MBA Admission Through Management
                  Quota becomes a viable and strategic option for deserving
                  candidates.
                </div>
              </div>
            </div>
          </div>

          <div className="mt-5">
            <CommonContactButton />
          </div>

          {/* general eligibility */}

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              What is Management Quota?
            </h2>
            <div>
              <p className="!text-[#616162]">
                Management quota is a<b>reserved</b> category of seats in
                private colleges and deemed universities, typically ranging
                between 5% to 20% of the total seat intake. These seats are
                filled by the college management directly and not through the
                centralized admission process. MBA Admission Through Management
                Quota allows students to secure admission based on eligibility
                criteria without a high percentile in CAT, MAT, or other
                entrance exams.
              </p>
            </div>
          </div>
          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Why Opt for MBA Admission Through Management Quota?
            </h2>
            <div>
              <p className="!text-[#616162]">
                There are several reasons why students consider MBA
              </p>
            </div>
            <div>
              <h3 className="text-[#1a1c45] font-semibold text-[18px] md:text-[15px] sm:text-[18px] mb-3 leading-none mt-4">
                Admission Through Management Quota:
              </h3>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-decimal">
                <li>
                  Avoiding Competitive Exams: Not every student scores
                  exceptionally in entrance exams. Management quota offers a
                  second chance.
                </li>
                <li>
                  Time-Saving: The lengthy counseling process can be skipped,
                  making admissions quicker.
                </li>
                <li>
                  Wider Choice of Colleges: Many top-ranked private MBA colleges
                  in India offer management quota seats.
                </li>
                <li>
                  Career Advancement: It enables students to join an MBA program
                  without losing a year.
                </li>
              </ol>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Eligibility Criteria for MBA Admission Through Management Quota
            </h2>
            <div>
              <p className="!text-[#616162]">
                Even though the admission is not merit-based, colleges still
                maintain basic eligibility standards. Generally, the following
                criteria are expected:
              </p>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>
                  A minimum of 50% marks in graduation (45% for reserved
                  categories)
                </li>
                <li>
                  Some institutions may ask for entrance test scores
                  (CAT/XAT/CMAT/MAT), but this is not mandatory
                </li>
                <li>
                  Work experience, if available, can be an added advantage
                </li>{" "}
                <li>
                  <b>Medical Fitness:</b>
                  Candidates must be medically fit and capable of undergoing
                  clinical training.
                </li>
              </ol>
              <p className="mt-2">
                It’s important to understand that MBA Admission Through
                Management Quota is not a shortcut but an alternative route for
                capable students who missed the cutoff.
              </p>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Admission Process: Step-by-Step
            </h2>
            <div>
              <p className="!text-[#616162]">
                Here is how the MBA Admission Through Management Quota process
                usually works
              </p>
            </div>
            <div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 ">
                <li>
                  <b> Step 1:Research and Shortlist Colleges:</b>
                  <div>
                    Focus on colleges that offer direct admission through
                    management quota.
                  </div>
                </li>
                <li className="mt-2">
                  <b>Step 2:Contact College Admission Cells or Consultants: </b>
                  <div>
                    Reach out to official admission departments or trusted
                    education consultants.
                  </div>
                </li>
                <li className="mt-2">
                  <b>Step 3:Submit Documents:</b>
                  <div>
                    Provide academic records, ID proofs, and passport-size
                    photos.
                  </div>
                </li>
                <li className="mt-2">
                  <b>Step 4: Application Fee and Booking Amount:</b>
                  <div>
                    Some colleges require a non-refundable token amount..
                  </div>
                </li>
                <li className="mt-2">
                  <b>Step 5:Final Admission and Fee Payment:</b>
                  <div>
                    Once selected, complete the full fee payment as per college
                    norms.
                  </div>
                </li>{" "}
              </ol>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Top MBA Colleges Offering Management Quota Admission
            </h2>
            <div>
              <p className="!text-[#616162]">
                Here are some reputed colleges known for MBA Admission Through
                Management Quota:
              </p>
            </div>
            <div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>Symbiosis Institute of Business Management (Pune)</li>
                <li>MIT School of Management (Pune)</li>
                <li>Amity Business School (Noida)</li>
                <li>Christ University (Bangalore)</li>
                <li>Jain University (Bangalore)</li>
                <li>NMIMS (Mumbai – for limited courses)</li>
                <li>ISBR Business School (Bangalore)</li>
                <li>Balaji Institute of Modern Management (Pune)</li>
                <li>ICFAI Business School (Hyderabad and other locations)</li>
              </ol>
            </div>

            <p>
              These institutions offer quality education and excellent placement
              records, making them top choices for{" "}
              <b> MBA Admission Through Management Quota</b>.
            </p>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Fees for MBA Admission Through Management Quota
            </h2>
            <div>
              <p className="!text-[#616162]">
                One key difference in this admission route is the fee structure.
                Management quota seats typically cost more than merit-based
                seats. Here’s a breakdown:
              </p>
            </div>
            <div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>
                  <b>Tuition Fees: </b>₹5,00,000 to ₹25,00,000 (varies by
                  college ranking and location)
                </li>{" "}
                <li>
                  <b>Miscellaneous Charges:</b> Hostel, registration, and
                  activity fees may apply
                </li>
                <li>
                  <b>One-time Donation (in some colleges):</b> Ranges from
                  ₹1,00,000 to ₹5,00,000
                </li>
              </ol>

              <p className="mt-3">
                Even though the costs are higher, the long-term return on
                investment (ROI) in terms of career growth often justifies the
                expense of MBA Admission Through Management Quota.
              </p>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Documents Required for Admission
            </h2>
            <div>
              <p className="!text-[#616162]">
                To complete MBA Admission Through Management Quota, the
                following documents are typically needed:
              </p>
            </div>

            <div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>10th and 12th mark sheets and certificates</li>{" "}
                <li>Graduation degree and transcripts</li>
                <li>ID proof (Aadhaar/PAN/Passport)</li>
                <li>Passport-size photographs</li>
                <li>Migration certificate (if applicable)</li>
                <li>Entrance exam scorecard (optional)</li>
              </ol>
              <p>
                Having all documents ready helps in speeding up the process and
                avoiding delays.
              </p>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Frequently Asked Questions (FAQs)
            </h2>

            <div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 ">
                <li>
                  <b>Q1: Is Management Quota Legal?</b>
                  <div>
                    Yes,<b> MBA Admission Through Management Quota</b> is
                    completely legal and recognized by AICTE and UGC, as long as
                    it is carried out within the guidelines issued by regulatory
                    bodies. Every private college is permitted to reserve a
                    certain percentage of seats under management quota.
                  </div>
                </li>
                <li className="mt-2">
                  <b>Q2:When to Apply?</b>
                  <div>
                    The ideal time to apply for MBA Admission Through Management
                    Quota is between May and August, as most colleges start
                    their academic session by July or August. However, early
                    application is recommended to ensure seat availability and
                    better college options.
                  </div>
                </li>
              </ol>
            </div>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              MBA Specializations Offered Under Management Quota
            </h2>
            <div>
              <p className="!text-[#616162]">
                Most colleges offer the full range of MBA specializations
                through management quota, including:
              </p>
            </div>

            <div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>Marketing</li>
                <li>Finance</li>
                <li>Human Resource Management</li>
                <li>International Business</li>
                <li>Business Analytics</li>
                <li>Operations</li>
                <li>IT Management</li>
                <li>Entrepreneurship</li>
                <li>Supply Chain Management</li>
              </ol>

              <p className="mt-3">
                With a degree from a respected college like DY Patil, your job
                prospects are strong both in India and internationally.
              </p>
            </div>
          </div>
          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Placement Opportunities
            </h2>
            <div>
              <p className="!text-[#616162]">
                A major concern for students is whether management quota
                students get the same placement opportunities. The answer is
                yes. Once enrolled, all students are treated equally, and
                placement assistance is provided across the board. Companies do
                not differentiate based on the mode of admission. Therefore, MBA
                Admission Through Management Quota still allows access to
                top-tier companies, internships, and corporate training
                opportunities.
              </p>
            </div>

            <div>
              <div className="text-[#1a1c45] font-semibold text-[18px] md:text-[15px] sm:text-[18px]  leading-none mt-4">
                Role of Education Consultants
              </div>
              <p>
                Applying through management quota often involves interaction
                with authorized admission consultants. They:
              </p>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>
                  Guide you in selecting the right college based on your budget
                  and profile
                </li>
                <li>
                  Handle the paperwork and follow-up with admission offices
                </li>
                <li>Ensure transparent and ethical admission</li>
              </ol>
              <p>
                Always choose a reputed and verified consultant to avoid frauds
                and overcharging. At Counselling India, we specialize in MBA
                Admission Through
              </p>
            </div>
            <p className="mt-3">
              Always choose a reputed and verified consultant to avoid frauds
              and overcharging. At Counselling India, we specialize in MBA
              Admission ThroughManagement Quota and have helped over 5000
              students secure their future
            </p>
          </div>

          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Common Myths About Management Quota
            </h2>
            <div>
              <p className="!text-[#616162]">
                Let’s debunk some misconceptions:
              </p>
            </div>

            <div>
              <ol className="!text-[#616162] mt-4 ml-10  md:ml-5 list-disc">
                <li>
                  <p>
                    {" "}
                    <b>Myth:</b> It’s only for rich students
                  </p>
                  <p>
                    <b>Fact:</b>
                    Many middle-class families opt for this route as an
                    investment in their child’s career.
                  </p>
                </li>
                <li>
                  <p>
                    {" "}
                    <b>Myth:</b> Quality of education is lower
                  </p>
                  <p>
                    <b>Fact:</b>
                    All students, regardless of admission mode, undergo the same
                    curriculum and exams.
                  </p>
                </li>
                <li>
                  <p>
                    {" "}
                    <b>Myth:</b> : No placements
                  </p>
                  <p>
                    <b>Fact:</b>
                    Placement is merit and performance-based, not
                    admission-route based..
                  </p>
                </li>
              </ol>
              <p>
                These myths should not deter capable candidates from considering
                MBA Admission Through Management Quota.
              </p>
            </div>
          </div>
          <div className="mt-[50px]">
            <h2 className="text-[#1a1c45] font-semibold text-[30px] md:text-[22px] sm:text-[18px] mb-4 leading-none">
              Final Thoughts
            </h2>

            <div>
              Pursuing an MBA is a life-changing decision that opens up global
              career opportunities. For students who miss out on competitive
              entrance exams, MBA Admission Through Management Quota is a
              legitimate and valuable alternative. It ensures you don’t lose a
              year and helps you get started on your management career in a
              reputed college. At the end of the day, what matters most is how
              you perform during your MBA program and how you utilize the
              opportunities given.
            </div>
          </div>

          <div className="mt-[50px]">
            <h2>FAQ’S</h2>

            <h6 className="mt-6">
              ❓ FAQ 1: What is MBA Admission Through Management Quota?
            </h6>
            <p>
              MBA Admission Through Management Quota is a special route that
              allows students to secure a seat in top MBA colleges even if they
              haven’t scored very high marks in entrance exams like CAT, MAT, or
              XAT. Many private institutions in India reserve a certain
              percentage of seats (typically 10% to 20%) under the management
              quota. These seats are filled at the discretion of the college’s
              management and are mainly aimed at helping deserving students who
              might have missed the cut-off due to intense competition. Opting
              for MBA Admission Through Management Quota is legal and governed
              by guidelines set by the respective state governments and the
              college authorities. It saves you from the stress of multiple
              entrance tests and gives you a second chance to pursue an MBA in a
              reputed college. However, the fees for MBA Admission Through
              Management Quota may be slightly higher than regular seats, so
              students and parents should plan their budgets accordingly. It’s
              important to approach only trusted admission consultants to ensure
              transparency and genuine allotment of seats.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 2: Who is eligible for MBA Admission Through Management
              Quota?
            </h6>
            <p>
              Students seeking MBA Admission Through Management Quota must
              fulfill basic eligibility criteria set by the university or
              institute. Typically, the candidate should have completed a
              Bachelor’s degree in any discipline from a recognized university
              with a minimum aggregate of 50% marks (45% for reserved
              categories). Although entrance exam scores may not be strictly
              mandatory for MBA Admission Through Management Quota, some
              colleges may still prefer students with valid scores to ensure
              academic quality. It’s crucial to remember that MBA Admission
              Through Management Quota is not a shortcut for unqualified
              students but an opportunity for genuine candidates who, due to
              reasons like missed deadlines, average entrance scores, or limited
              seats, could not secure admission through the general quota. Also,
              students must provide necessary documents like mark sheets, ID
              proof, and sometimes an undertaking stating the purpose for opting
              for MBA Admission Through Management Quota. By meeting these
              requirements, students can smoothly get admitted to top MBA
              colleges and pursue their management dreams.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 3: How much does MBA Admission Through Management Quota
              cost?
            </h6>
            <p>
              The fee for MBA Admission Through Management Quota varies widely
              depending on the reputation of the institute, location, and the
              specialization you choose. Generally, the tuition fee under the
              management quota can be higher than the merit quota because it
              includes a seat booking or donation component. For example, an MBA
              in a tier-1 college might cost anywhere between ₹10 lakhs to ₹25
              lakhs for MBA Admission Through Management Quota, while tier-2 or
              tier-3 colleges might charge ₹5 lakhs to ₹12 lakhs. This fee
              structure typically covers tuition, campus facilities, and other
              academic costs. It’s important for parents and students to verify
              the total fee structure directly with the college and get a clear,
              written breakdown. Many colleges also offer installment options or
              tie-ups with banks for education loans to make paying for MBA
              Admission Through Management Quota easier. Transparency is key —
              always take official receipts and maintain records to avoid hidden
              charges or scams during the MBA Admission Through Management Quota
              process.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 4: Is MBA Admission Through Management Quota legal in
              India?
            </h6>
            <p>
              Yes, MBA Admission Through Management Quota is 100% legal in India
              and is regulated by state education boards and private
              universities. According to guidelines by statutory bodies like
              AICTE (All India Council for Technical Education) and state
              governments, private self-financed institutions are allowed to
              reserve a certain percentage of seats under the management quota.
              This provision ensures that students who genuinely want to pursue
              an MBA but couldn’t clear entrance exams due to high competition
              still have an opportunity to enroll in reputed institutes.
              Colleges that offer MBA Admission Through Management Quota must
              disclose the number of seats available under this quota and follow
              fair practices during allocation. It is always advisable for
              students to approach the college’s admission office directly or
              work through registered admission consultants to ensure the
              process is transparent. Remember, misuse of the MBA Admission
              Through Management Quota or dealing with unauthorized agents can
              lead to fraud and loss of money, so proceed carefully and only
              through legitimate channels.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 5: Which colleges offer MBA Admission Through Management
              Quota?
            </h6>
            <p>
              Many reputed private colleges and universities across India offer
              MBA Admission Through Management Quota to help deserving students
              secure their management education. Popular institutes like
              Symbiosis Institute of Business Management, MIT Pune, PES
              University, Christ University Bangalore, M.S. Ramaiah Institute,
              and Welingkar Institute Mumbai are some examples where a portion
              of seats are reserved under the management quota. However, the
              availability of MBA Admission Through Management Quota seats
              depends on the institute’s policies and seat matrix approved by
              the government or university. Students should research colleges,
              verify their accreditation status (like AICTE, NAAC), and check
              past placement records before applying for MBA Admission Through
              Management Quota. The best practice is to directly contact the
              official admission office of the college or seek assistance from
              reputed admission consultants who can guide you about seat
              availability, documentation, fee structure, and the right time to
              apply for MBA Admission Through Management Quota to secure your
              seat without hassles.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 6: What documents are required for MBA Admission Through
              Management Quota?
            </h6>
            <p>
              When applying for MBA Admission Through Management Quota, students
              must be ready with all necessary documents to complete the
              admission process smoothly. The standard list includes your 10th
              and 12th mark sheets, Bachelor’s degree mark sheets and
              provisional or original degree certificate, entrance exam score
              card (if applicable), transfer certificate, migration certificate
              (for students from other universities), recent passport-size
              photographs, and valid ID proof like Aadhaar card or passport.
              Some colleges may also ask for a character certificate and a gap
              certificate if there’s a break in education. For MBA Admission
              Through Management Quota, students may need to sign a declaration
              or undertaking form stating that the seat is secured under the
              management quota and all provided information is correct. Always
              carry both originals and multiple attested photocopies of all
              documents. Keeping documents ready helps avoid last-minute issues
              and ensures a hassle-free MBA Admission Through Management Quota
              process in your chosen college.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 7: What are the advantages of MBA Admission Through
              Management Quota?
            </h6>
            <p>
              MBA Admission Through Management Quota provides several practical
              advantages for students. Firstly, it acts as a backup option for
              students who could not clear competitive exams like CAT or MAT or
              didn’t get shortlisted during counseling rounds. It saves an
              entire academic year as students can still join top colleges
              without waiting for the next exam cycle. Secondly, MBA Admission
              Through Management Quota gives you more control over college
              selection, allowing you to choose a college and specialization
              best suited to your career goals. Thirdly, it reduces the stress
              and uncertainty caused by fluctuating cut-offs and intense
              competition. Many students also use MBA Admission Through
              Management Quota to secure admission in colleges closer to home or
              with better placement records. Lastly, reputed institutes maintain
              the same quality of education, faculty, and placement
              opportunities for management quota students as regular students,
              ensuring no compromise on career prospects. Therefore, MBA
              Admission Through Management Quota is a wise choice for students
              who want a guaranteed seat in a good B-school.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 8: When should I apply for MBA Admission Through Management
              Quota?
            </h6>
            <p>
              Timing is crucial for MBA Admission Through Management Quota
              because these seats are limited and fill up quickly. Ideally,
              students should start their research and preparation immediately
              after their final-year degree results or entrance exam results are
              declared. Most colleges open their MBA Admission Through
              Management Quota applications along with regular admissions but
              allot seats on a first-come, first-served basis. Therefore, early
              application increases your chances of getting your preferred
              specialization and campus. It’s advisable to contact the college’s
              admission office or a trusted admission consultant at least 3-6
              months before the academic session starts. Have all documents
              ready and arrange finances in advance as MBA Admission Through
              Management Quota often requires an upfront payment of tuition or
              seat confirmation fees. By planning early, you avoid the stress of
              last-minute rush and ensure that you secure a seat in your dream
              college under MBA Admission Through Management Quota without any
              complications.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 9: Is the placement different for students who take MBA
              Admission Through Management Quota?
            </h6>
            <p>
              One common myth is that students who secure MBA Admission Through
              Management Quota face discrimination in placements — but this is
              not true. Most reputable MBA colleges maintain equal academic and
              placement opportunities for all students, regardless of whether
              they joined through general quota, reserved quota, or management
              quota. Employers and recruiters focus on your skills, performance,
              internship experience, and overall personality, not on how you
              secured your seat. Institutes offering MBA Admission Through
              Management Quota ensure that all students undergo the same
              training, participate in the same placement drives, and compete
              equally for top jobs. However, it’s up to the student to utilize
              college resources like internships, networking events, workshops,
              and guest lectures to boost their profile. Therefore, students
              opting for MBA Admission Through Management Quota should stay
              focused, perform well academically, and actively participate in
              campus activities to build a strong resume that attracts good
              placement opportunities.
            </p>
            <h6 className="mt-5">
              ❓ FAQ 10: How can I find a trusted consultant for MBA Admission
              Through Management Quota?
            </h6>
            <p>
              Finding a genuine consultant for MBA Admission Through Management
              Quota is crucial to avoid fraud or false promises. First, look for
              consultants who have years of experience and positive reviews from
              past students. Always check if they have an official office, valid
              website, and verifiable contact details. Reputed consultants
              provide transparent information about colleges, fee structures,
              seat availability, and documentation for MBA Admission Through
              Management Quota. Avoid agents who demand full payment upfront or
              guarantee admission without any official communication from the
              college. Always ask for receipts for every payment you make and
              try to keep your family involved in all discussions. Another smart
              step is to verify directly with the college admission office
              whether the consultant is authorized for MBA Admission Through
              Management Quota counseling for that institute. Trusted
              consultants guide you throughout the process, from counseling and
              documentation to final seat allotment, ensuring your journey for
              MBA Admission Through Management Quota is smooth, legal, and
              stress-free.
            </p>
          </div>
        </Container>
      </section>

      {/* instruction section start  */}

      {/* top college details start*/}

      {/* enquiry form section start */}
      <m.section
        className="py-[160px] bg-cover 	bg-no-repeat overflow-hidden relative bg-center lg:py-[120px] md:py-[95px] xs:py-[80px] xxs:py-[50px]"
        style={{
          backgroundImage:
            "url(/assets/img/webp/MedicalCounsellingIndia/home/enquiry/enquiry.webp)",
        }}
        {...fadeIn}
      >
        <Container className="xs:px-0">
          <div className="flex justify-center mb-[100px] w-full">
            <p className="font-normal text-[20px] w-[70%] lg:w-[70%] md:w-[100%] text-center">
              Get Top Education Consultant in Jamshedpur. Kindly submit your
              data below and we shall connect you as soon as possible.
            </p>
          </div>
          <Row className="justify-end md:justify-center">
            <Col xl={7} lg={7} md={9} sm={11}>
              <div className="px-[3rem] py-[5rem] rounded-md shadow-[0_0_30px_rgb(0,0,0,0.08)] bg-white sm:p-20 xs:rounded-none xs:px-[3.5rem] xs:py-[6rem]">
                <span className="mb-[15px] font-medium text-center text-[#f78c1f] text-md font-serif uppercase block sm:mb-[10px]">
                  Submit your details here
                </span>
                <h5 className="w-[80%] mb-[40px] font-bold text-center	tracking-[-1px] text-black font-serif uppercase mx-auto xs:w-full">
                  YOU ARE JUST A CALL AWAY
                </h5>

                <form className="mb-[30px]" onSubmit={handleSubmit(onSubmit)}>
                  <m.div
                    className="row justify-center"
                    {...{ ...fadeIn, transition: { delay: 0.6 } }}
                  >
                    <Col xl={6} lg={6} md={6} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="text"
                          name="name"
                          className="rounded-[5px] relative py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your name"
                          {...register("name", {
                            required: {
                              value: true,
                              message: "Name is required",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.name?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="text"
                          name="email"
                          className="rounded-[5px] py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your email address"
                          {...register("email", {
                            required: {
                              value: true,
                              message: "Email is required.",
                            },
                            pattern: {
                              value:
                                /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
                              message: "Enter valid email",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.email?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="number"
                          name="phone"
                          className="rounded-[5px] py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your phone number"
                          onKeyDown={handleKeyDown}
                          {...register("phone", {
                            required: {
                              value: true,
                              message: "Phone number is required",
                            },
                            pattern: {
                              value:
                                /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
                              message: "Enter valid phone number",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.phone?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="text"
                          name="address"
                          className="rounded-[5px] py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your address"
                          {...register("address", {
                            required: {
                              value: true,
                              message: "Address is required",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.address?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12}>
                      <div className="mb-[33px]">
                        <input
                          type="text"
                          name="stream"
                          className="rounded-[5px] py-[13px] px-[20px] w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Subject"
                          {...register("stream", {
                            required: {
                              value: true,
                              message: "Stream is required",
                            },
                            value: "Subject",
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-3px] translate-x-[10px]">
                          {errors.stream?.message}
                        </div>
                      </div>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12}>
                      <div className="mb-[33px]">
                        <textarea
                          type="text"
                          rows={3}
                          name="message"
                          className="rounded-[5px] py-[13px] px-[20px]  w-full border-[1px] border-solid border-[#dfdfdf] overflow-hidden"
                          placeholder="Your message"
                          {...register("message", {
                            required: {
                              value: true,
                              message: "Message is required",
                            },
                          })}
                        />
                        <div className="absolute text-[tomato] text-[12px] translate-y-[-10px] translate-x-[10px]">
                          {errors.message?.message}
                        </div>
                      </div>
                    </Col>
                  </m.div>

                  <Buttons
                    type="submit"
                    className={`btn-fill text-sm leading-none font-medium tracking-[1px] !py-[17px] px-[32px] rounded-[4px] w-full uppercase mb-[5px] ${
                      formLoading ? "loading" : ""
                    }`}
                    themeColor="#f78c1f"
                    color="#fff"
                    size="lg"
                    title="Request a call schedule"
                  />
                </form>
              </div>
            </Col>
          </Row>
        </Container>
        <ToastContainer />
      </m.section>
      {/* enquiry form section end */}
    </>
  );
}

export default AdmissionThroughManagementQuota;
